module.exports = __webpack_public_path__ + "media/images/common/new_entry_btn2-343ebeb541df52696f1f84cd47cdaa37.png";